import React from 'react'
import { withRouter } from 'react-router-dom'

import { MenuButton } from '@driftt/dds'
import { access } from '@driftt/traffic-control'

import './style.css'

const ManageAccounts = ({ addNew = () => {}, history }) => {
  const renderDefaultActions = () => {
    const defaultActions = [
      {
        action: () => addNew(),
        name: 'Add single account',
      },
      {
        action: () => window.open('/settings2/integrations/detail/salesforce'),
        name: 'Sync from Salesforce',
      },
    ]

    if (access.hasGates('ACCOUNTS_IMPORT')) {
      defaultActions.splice(2, 0, ({
        action: () => history.push('/imports/new'),
        name: 'Import CSV',
      }))
    }

    return defaultActions
  }

    return (
      <MenuButton buttonText="Manage accounts" options={renderDefaultActions()} />
    )
}

export default withRouter(ManageAccounts)
